module.exports = __webpack_public_path__ + "media/images/afterpay_logo-ae9998864fb629901e16da2097042c6c.png";